export default __webpack_public_path__ + "static/media/life-icon.c754cfeb.svg";